export default __webpack_public_path__ + "static/media/sanmat4.fecf998a.jpg";